<form nz-form [formGroup]="form" class="user-form">

  <!-- პირადი ინფორმაცია -->
  <div class="form-section">
    <div class="section-header">
      <span nz-icon nzType="user" nzTheme="outline"></span>
      <span>{{ 'users.sections.personalInfo' | translate }}</span>
    </div>
    <div nz-row [nzGutter]="[16, 4]">
      <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
        <beautyapp-input
          formControlName="firstname"
          [label]="'users.form.name' | translate"
          [required]="true"
          size="large"
        ></beautyapp-input>
      </div>
      <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
        <beautyapp-input
          formControlName="lastname"
          [label]="'users.form.lastName' | translate"
          [required]="true"
          size="large"
        ></beautyapp-input>
      </div>
      <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
        <beautyapp-select
          label="{{'users.form.gender' | translate}}"
          [data]="genders"
          displayMember="value"
          valueMember="id"
          formControlName="gender"
          [required]="true"
          size="large"
        ></beautyapp-select>
      </div>
      <!--
        beaut-559: when the branch has hidden this field from the viewer's role
        it arrives masked, the control is disabled, and the value is never
        submitted. The placeholder says so out loud — an empty disabled box
        otherwise reads as "this customer has no personal number", and sends
        somebody hunting for data that is simply not theirs to see.
      -->
      <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
        <beautyapp-input
          formControlName="identityNumber"
          [label]="'users.form.idNumber' | translate"
          [required]="personalIdRequired && !isHidden('identityNumber')"
          [errors]="{ pattern: personalIdError }"
          [placeholder]="isHidden('identityNumber') ? 'დამალულია' : ''"
          size="large"
        ></beautyapp-input>
      </div>
      <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
        <beautyapp-datepicker
          formControlName="birthDate"
          [label]="'users.form.dateOfBirth' | translate"
          size="large"
        ></beautyapp-datepicker>
      </div>
      <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
        <beautyapp-select
          label="{{'სისხლის ჯგუფი' | translate}}"
          [data]="bloodGroups"
          displayMember="alias"
          valueMember="value"
          formControlName="bloodGroup"
          size="large"
        ></beautyapp-select>
      </div>
    </div>
  </div>

  <!-- საკონტაქტო ინფორმაცია -->
  <div class="form-section">
    <div class="section-header">
      <span nz-icon nzType="phone" nzTheme="outline"></span>
      <span>{{ 'users.sections.contactInfo' | translate }}</span>
    </div>
    <div nz-row [nzGutter]="[16, 4]">
      <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
        <beautyapp-input
          formControlName="mobilePhone"
          [label]="'users.form.phoneNumber' | translate"
          [required]="true"
          size="large"
        ></beautyapp-input>
      </div>
      <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
        <beautyapp-input
          formControlName="phone"
          [label]="'users.form.homePhone' | translate"
          size="large"
        ></beautyapp-input>
      </div>
      <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
        <beautyapp-input
          formControlName="email"
          [label]="'users.form.email' | translate"
          size="large"
        ></beautyapp-input>
      </div>
      <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
        <beautyapp-select
          formControlName="countryId"
          label="{{'realization.form.country' | translate}}"
          [data]="countries()"
          displayMember="name"
          valueMember="id"
          size="large"
        ></beautyapp-select>
      </div>
      <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
        <beautyapp-select
          formControlName="cityId"
          label="{{'realization.form.city' | translate}}"
          [data]="cities()"
          displayMember="name"
          valueMember="id"
          size="large"
        ></beautyapp-select>
      </div>
      <div nz-col [nzXs]="24" [nzLg]="16">
        <beautyapp-input
          formControlName="address"
          label="{{'realization.form.address' | translate}}"
          size="large"
        ></beautyapp-input>
      </div>
    </div>
  </div>

  <!-- დამატებითი ინფორმაცია -->
  <div class="form-section">
    <div class="section-header">
      <span nz-icon nzType="info-circle" nzTheme="outline"></span>
      <span>{{ 'users.sections.additionalInfo' | translate }}</span>
    </div>
    <div nz-row [nzGutter]="[16, 4]">
      <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
        <beautyapp-input
          formControlName="cardNo"
          [label]="'users.form.cardNo' | translate"
          size="large"
        ></beautyapp-input>
      </div>
      <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
        <beautyapp-select
          label="{{'users.form.userSource' | translate}}"
          [data]="userSources()"
          displayMember="name"
          valueMember="id"
          formControlName="userSourceId"
          size="large"
        ></beautyapp-select>
      </div>
      <div nz-col [nzXs]="24" [nzSm]="12" [nzLg]="8">
        <beautyapp-select
          label="{{ 'users.form.smsLanguage' | translate }}"
          [data]="smsLanguages"
          displayMember="value"
          valueMember="id"
          formControlName="smsLanguage"
          size="large"
        ></beautyapp-select>
      </div>
      <div nz-col [nzSpan]="24">
        <beautyapp-input
          formControlName="workplace"
          label="{{'realization.form.workingPlace' | translate}}"
          size="large"
        ></beautyapp-input>
      </div>
      <div nz-col [nzSpan]="24">
        <beautyapp-textarea
          size="large"
          formControlName="description"
          [label]="'users.form.additionalInformation' | translate"
          placeholder="{{'users.form.additionalInformation' | translate}}"
        ></beautyapp-textarea>
      </div>
    </div>
  </div>

</form>
<div *nzModalFooter>
  <!-- beaut-382: show the in-flight state so the user can't double-click Save
       into two requests (submit() also guards re-entry). -->
  <button
    nz-button
    nzType="primary"
    nzSize="large"
    [nzLoading]="saving"
    [disabled]="saving"
    (click)="submit()"
  >
    <span nz-icon nzType="save" nzTheme="outline"></span>
    {{ 'buttons.save' | translate }}
  </button>
</div>
